var makeString = require('./helper/makeString');

module.exports = function isBlank(str) {
  return (/^\s*$/).test(makeString(str));
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/isBlank.js
 ** module id = 390
 ** module chunks = 0
 **/